var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { styled } from '@stitches/react';
import { FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight, FiMoreHorizontal, } from 'react-icons/fi';
import { PaginationContext } from './Pagination';
var PaginationItemElement = styled('button', {});
export var PaginationItem = function (_a) {
    var _b;
    var page = _a.page, itemType = _a.itemType, isActive = _a.isActive, isDisabled = _a.isDisabled, onClick = _a.onClick;
    var _c = React.useContext(PaginationContext), itemComponent = _c.itemComponent, labels = _c.labels, itemCss = _c.itemCss;
    var elementProps = {};
    var Element = itemComponent || PaginationItemElement;
    if (itemComponent) {
        elementProps = {
            isActive: isActive,
            isDisabled: isDisabled || itemType === 'ellipsis',
            ariaLabel: itemType === 'page' ? "Page " + page : itemType,
        };
    }
    else {
        elementProps = {
            css: itemCss,
            disabled: isDisabled || itemType === 'ellipsis',
            'aria-label': itemType === 'page' ? "Page " + page : itemType,
            'aria-current': isActive ? 'true' : 'false',
        };
    }
    return (React.createElement(React.Fragment, null, (labels === null || labels === void 0 ? void 0 : labels[itemType]) !== false && (React.createElement(Element, __assign({ onClick: onClick }, elementProps), itemType === 'previous'
        ? (labels === null || labels === void 0 ? void 0 : labels.previous) || React.createElement(FiChevronLeft, null)
        : itemType === 'next'
            ? (labels === null || labels === void 0 ? void 0 : labels.next) || React.createElement(FiChevronRight, null)
            : itemType === 'first'
                ? (labels === null || labels === void 0 ? void 0 : labels.first) || React.createElement(FiChevronsLeft, null)
                : itemType === 'last'
                    ? (labels === null || labels === void 0 ? void 0 : labels.last) || React.createElement(FiChevronsRight, null)
                    : itemType === 'ellipsis'
                        ? (labels === null || labels === void 0 ? void 0 : labels.ellipsis) || React.createElement(FiMoreHorizontal, null)
                        : (labels === null || labels === void 0 ? void 0 : labels.page) && typeof (labels === null || labels === void 0 ? void 0 : labels.page) !== 'boolean'
                            ? (_b = labels === null || labels === void 0 ? void 0 : labels.page) === null || _b === void 0 ? void 0 : _b.call(labels, page)
                            : page))));
};
